import React, { Component } from 'react'
import { Row, Col, Table, Icon, Button, Popconfirm } from 'antd'
import { Link } from 'react-router-dom'
import apaLogo from '../assets/images/apalogo_big.png'
import moment from 'moment'

import IssuesModel from '../models/IssuesModel'
import AuthModel from '../models/AuthModel'

import Permissions from '../models/Permissions'

class PublicHome extends Component {

    state = {
        submitbyOptions: []
    };

    getSubmitedLabel(item) {
        var label = '';
        switch(item.tecnico) {
            case 'public': label = 'Público'; break;
            default: label = 'Técnico'; break;
        }
        return label;
    }

    componentWillReceiveProps(nextProps) {
        const submitbyOptions = [];
        nextProps.items.map((item) => {
            var label = this.getSubmitedLabel(item);
            var exists = submitbyOptions.filter(o => o.text === label);
            if (exists.length === 0) {
                submitbyOptions.push({key: item.id, text: label, value: label});
            }
            item.key = item.id
            return item
        });
        this.setState({
            ...this.state,
            data: nextProps.items,
            submitbyOptions: submitbyOptions
        })
    }

    filter(field, query, data) {
        const reg = new RegExp(query, 'gi');
        const items = data.map((record) => {
            const match = record[field].match(reg);
            if (!match) return null;
            return {
                ...record,
                name: (
                <span>
                    {record[field].split(reg).map((text, i) => (
                    i > 0 ? [<span className="highlight">{match[0]}</span>, text] : text
                    ))}
                </span>
                ),
            };
        }).filter(record => !!record);
        return items;
    }

    onExportPDF(id, e) {
        e.preventDefault();
        var format = 'MROL_' + id +'.pdf';
        var mime = 'application/pdf';
        var url = IssuesModel.endpoint() + '/search/export/' + format + '?token=' + AuthModel.getAuthToken()
        url += '&id=' + id;
        IssuesModel.download(format, url, mime, () => {})
    }

    render() {
        const role = Permissions.getUserRole();
        let items = this.props.items;
        const columns = [];
        columns.push({
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: (a, b) => parseInt(a.id, 10) - parseInt(b.id, 10)
        });
        if (['superuser', 'apaadmin'].indexOf(role) > -1) {
            columns.push({
                title: 'Tipo de Registo',
                dataIndex: 'tecnico_utilizador_id',
                key: 'tecnico_utilizador_id',
                render: (text, r) => {
                    return this.getSubmitedLabel(r)
                },
                sorter: (a, b) => this.getSubmitedLabel(a) >= this.getSubmitedLabel(b) ? 1 : -1,
                filters: this.state.submitbyOptions,
                filterMultiple: false,
                onFilter: (v, r) => this.getSubmitedLabel(r) === v
            });
        } else {
            items = items.filter(i => this.getSubmitedLabel(i) === 'Técnico')
        }
        columns.push({
            title: 'Data do Registo',
            dataIndex: 'data_registo_local',
            key: 'data_registo_local',
            sorter: (a, b) => moment(a.data_registo_local).isAfter(b.data_registo_local) ? 1 : -1
        });
        columns.push({
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b) => a.status >= b.status ? 1 : -1,
            render: (text, r) => (
                <span>
                    { r.status === 'Guardada' ? (<Icon type="exclamation-circle-o" style={{color: 'orange'}} />)
                        : r.status === 'Anulada' ? (<Icon type="close-circle-o" style={{color: 'red'}} />)
                        : (<Icon type="check-circle-o" style={{color: 'green'}} />)
                    }
                    <span className="hide-small">{' '}{r.status}</span>
                </span>
            )
        });
        columns.push({
            title: 'Localização',
            dataIndex: 'freguesia',
            key: 'freguesia',
            sorter: (a, b) => {
                var aStr = (a.praia ? a.praia + ' | ' : '') + a.freguesia+' | '+a.concelho+' | '+a.distrito
                var bStr = (b.praia ? b.praia + ' | ' : '') + b.freguesia+' | '+b.concelho+' | '+b.distrito
                return aStr >= bStr ? 1 : -1
            },
            render: (text, r) => (
                <Link to={'/details/'+r.id}>
                    {r.praia ? r.praia + ' | ' : ''}{r.freguesia} | {r.concelho} | {r.distrito}
                </Link>
            )
        });
        columns.push({
            title: 'Opções',
            key: 'action',
            render: (text, record) => (
                <span>
                    <Link to="" title="PDF" onClick={(e) => this.onExportPDF(record.id, e)}>
                      <Icon type="file" style={{color: 'black'}} />
                    </Link>
                    {' '}
                    { !Permissions.isDenied('issues', 'update', record) ? (
                        <Link to={'/issue/' + record.id}>
                            <Icon type="edit" style={{color: 'green'}} />
                        </Link>
                    ) : '' }
                    {' '}
                    { !Permissions.isDenied('issues', 'delete', record) ? (
                        <Popconfirm title="DESTRUIR? Não poderá voltar atrás."
                            onConfirm={(e) => this.props.remove(record)}
                            okText="Sim" cancelText="Não">
                            <a role="button">
                                <Icon type="delete" style={{color: 'red'}} />
                            </a>
                        </Popconfirm>
                    ) : '' }
                </span>
            )
        });
        items.map((item) => {
            item.key = item.id
            return item
        })
        console.log('items', items);
        return (
            <Row>
                <Col span={24}>

                    { items.length ? (
                        <div id="ownIssues">
                            <h3>As Minhas Ocorrências</h3>
                            <Table dataSource={items} columns={columns} />
                        </div>

                    ) : (
                        <div>
                            <h1>
                                <img src={apaLogo} alt="APA Logo" title="APA Logo" style={{float: 'left', marginRight: '20px'}}/>
                                Reporte de Ocorrências no Litoral
                            </h1>
                            <hr />
                            <div style={{float: 'right'}}>
                                <Button type="primary" onClick={(e) => this.props.history.push('/preform')}>
                                    <Icon type="create" style={{color: 'green'}} /> Reportar Nova Ocorrência
                                </Button>
                            </div>
                        </div>
                    )}

                </Col>
            </Row>
        )
    }
}

export default PublicHome;



// WEBPACK FOOTER //
// ./src/components/PublicHome.js